import { Badge } from '@mui/material'
import { styled as muiStyled } from '@mui/material/styles';
import { BorderRadius } from 'styles/themeBorderRadius';
import { Space } from 'styles/themeSpaces';

const StyledBadge = muiStyled(Badge, {
  shouldForwardProp: (prop) => !['$bgColor', '$color', '$borderRadius'].includes(prop as string),
})<any>(({ $bgColor, $color, $borderRadius = BorderRadius.m }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: $bgColor,
    color: $color,
    minWidth: '20px',
    position: 'static',
    borderRadius: `${$borderRadius} !important`,
    marginLeft: Space.spHalf,
  },
  '& .MuiBadge-anchorOriginTopRightRectangular': {
    transform: 'none !important',
  },
}));

export default StyledBadge;
